import { UAParser } from 'ua-parser-js'

// only instantiate and parse once
const parser = new UAParser()
const result = parser.getResult()

export const isSafari = /Safari/.test(result.browser.name)
export const isMobile = /mobile|tablet|phone/i.test(result.device.type)
